import app from 'dvaInstance'

export const isSkitUser = () => {
  // @ts-expect-error : Will update later
  const store = app._store.getState()
  const user = store.auth?.user

  if (user && (user.email?.includes('@skit.ai') || user?.email.includes('@skitops.ai'))) {
    return true
  }
  return false
}
